import React, { useEffect, useState} from 'react';
import { Col, Form, Row } from 'antd';
import { FormField, Label } from 'components';
import { updateFormField } from 'store/forms/actions';
import { formFields2_1, formFields2_2 } from './formFields';
import { useDispatch, useSelector } from 'react-redux';
import { get, omit, isNil, isEmpty, isEqual } from 'lodash';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { getFullDate , isBeneficiary } from 'utils';
// import SorefsisChart from '../sorefsisChart';
// import Sorefsis from 'components/sorefsis';

const CompanyDetails = () => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const carrier = useSelector(state => state.forms.carrier);
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const applicationReturned = useSelector(state => state.forms?.carrier?.applicationReturned); 
  const activeTaskName = useSelector(state => state?.forms?.activeTaskName); 
  const viewMode = isViewMode || 
                  !isBeneficiary(user.groups) || 
                  applicationReturned ||
                  activeTaskName === "task.name.temporary_rejected" ||
                  activeTaskName === "task.name.application_returned_to_supplier" ||
                  activeTaskName === "task.name.accepted";
  const [abiPerfectureOptions, setAbiPerfectureOptions] = useState([]);
  const [abiDistrictOptions, setAbiDistrictOptions] = useState([]);
  const [tkOptions, setTkOptions] = useState([]);
  const kadBranches = useSelector(state => state.forms.kadBranches);
  const [filteredKadFirms, setFilteredKadFirms] = useState([]);
  // const mainKAD = useSelector(state => state.forms.carrier.mainKAD);
  const [sameMasterUser, setSameMasterUser] = useState(false);
  
  const carrierUsers = useSelector(
    state => state.forms.carrier.carrierUsers
  ) || [
    {
      userLName: carrier?.companyName ? carrier?.companyName : '',
      userPhone: carrier?.invMob ? carrier?.invMob : '',
      userEmail: carrier?.invMail ? carrier?.invMail : '',
    },
  ];
  
  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  useEffect(() => {
    if (user.taxis_data) {
      setTkOptions(user.taxis_data?.tks?.map(item => ({
        label: item.code,
        value: item.code,
      })))
      return Promise.all([
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'companyName',
            value: !isNil(user.taxis_data?.onomasia)
              ? user.taxis_data?.onomasia
                  .split(',')
                  .join(' ')
                  .split('  ')
                  .join(' ')
              : carrier.companyName,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'abiVat',
            value: !isNil(user.taxis_data?.afmTrimmed)
              ? user.taxis_data?.afmTrimmed
              : carrier.abiVat, //user.taxis_data?.afmTrimmed,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'regDate',
            value: !isNil(user.taxis_data?.registDate)
              ? getFullDate(user.taxis_data?.registDate)
              : carrier.regDate,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'abiStreetFull',
            value:
              !isNil(user.taxis_data?.firmAddress) &&
              !isNil(user.taxis_data?.firmAddressNo)
                ? user.taxis_data?.firmAddress +
                  ' ' +
                  user.taxis_data?.firmAddressNo
                : carrier.abiStreetFull,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'abiTk',
            value: carrier?.abiTk
          })
        ),
        
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'invMob',
            value: 
            !isNil(carrier.invMob)
              ? carrier.invMob
              : user?.taxis_data?.firmPhone,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'mainKAD',
            value: !isNil(user.taxis_data?.mainKadCode)
              ? user.taxis_data?.mainKadCode
              : carrier.mainKAD,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'mainKADDescription',
            value: !isNil(user.taxis_data?.mainKadDescription)
              ? user.taxis_data?.mainKadDescription
              : carrier.mainKADDescription,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'companySize',
            value: isNil(carrier.companySize) ? "Μικρή" : carrier.companySize,
          })
        ),
      ]);
    }
  }, [user.taxis_data]);


  useEffect(() => {
    if(isNil(carrier?.abiTk)) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiTk',
          value: !isNil(user.taxis_data?.firmZipCode)
          ? user.taxis_data?.firmZipCode
          : carrier.abiTk,
        })
      )
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiPerfecture',
          value:
            !isNil(user.taxis_data?.tks) &&
            !isNil(user.taxis_data?.tks[0].nomos)
              ? user.taxis_data?.tks[0].nomos
              : carrier.abiPerfecture,
        })
      )
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiDistrict',
          value: !isNil(user.taxis_data?.firmParDescr)
            ? user.taxis_data?.firmParDescr
            : carrier.abiDistrict,
        })
      )
    }
  } ,[user.taxis_data, tkOptions])

  useEffect(() => {
    form.setFieldsValue({
      companyName: carrier.companyName,
      abiVat: carrier.abiVat,
      regDate: carrier.regDate,
      abiStreetFull: carrier.abiStreetFull,
      abiTk: carrier.abiTk,
      abiPerfecture: carrier.abiPerfecture,
      abiDistrict: carrier.abiDistrict,
      invMob: carrier.invMob,
      mainKAD: carrier.mainKAD +' - ' + carrier.mainKADDescription,
      companySize: carrier.companySize,
      website: carrier.website,
      companyLegalType: carrier.companyLegalType,
      invMail: carrier.invMail,
    });
    
    //after refresh validators fire
    if((carrier.website)) form.validateFields(['website'])
    if((carrier.invMob)) form.validateFields(['invMob'])
    if((carrier.invMail)) form.validateFields(['invMail'])

  }, [form, carrier]);


  useEffect(()=>{
    setFilteredKadFirms(
      kadBranches?.getAllKadBranchesReturn?.kadFirmList?.kadFirmRecord
      .filter((firm) => firm.firmActKind !== "1")
      .map(firm => `${firm.firmActivity} - ${firm.firmDescr}`)
    );
  },[kadBranches?.getAllKadBranchesReturn])

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  useEffect(() => {
    if (tkOptions && user?.taxis_data?.tks) {
      const options = user?.taxis_data?.tks?.filter(item => item.code === carrier?.abiTk )
      .map(item => ({
        label: item.area,
        value: item.area,
      }));
      setAbiDistrictOptions(options);
    }

    if (tkOptions && user?.taxis_data?.tks) {
      const options = user?.taxis_data?.tks?.filter(item => item.code === carrier?.abiTk )
      .map(item => ({
        label: item.nomos,
        value: item.nomos,
      }));
      setAbiPerfectureOptions(options);
    }
  }, [carrier?.abiTk]);

  // ------------------------- Carrier Users Update ------------------------------ //
 //Initialize carrierUsers on mount if carrierUsers is empty
  useEffect(() => {
    if (!carrier?.carrierUsers || carrier?.carrierUsers.length === 0) {
      const masterUser = {
        userLName: carrier?.companyName || '',
        userPhone: carrier?.invMob || '',
        userEmail: carrier?.invMail || '',
        id:null,
      };


      dispatch(updateFormField({
        group: 'carrier',
        key: 'carrierUsers',
        value: [masterUser]
      }));
    }
  }, [carrier?.invMob, carrier?.invMail]);

  useEffect(() => {
      //The master user must be in first index, where index 0 is disabled
      const masterUser = {
        userLName: carrier?.companyName || '',
        userPhone: carrier?.invMob || '',
        userEmail: carrier?.invMail || '',
      };

      if (!carrier?.carrierUsers || carrier?.carrierUsers.length !== 0) {


        let tempMasterUser = carrierUsers.find(
        (user) =>
          user.userLName === (masterUser.userLName ? masterUser.userLName : '')
        );

        // console.log("tempMasterUser 1 ",tempMasterUser)


        let clonedArray = structuredClone(tempMasterUser);
        clonedArray = {
          ...tempMasterUser,
          userLName: carrier?.companyName || '',
          userPhone: carrier?.invMob || '',
          userEmail: carrier?.invMail || '',
        }

        // console.log("tempMasterUser 2 ",tempMasterUser)

        const filteredUsers = carrierUsers.filter(
          (user) =>
          user.userLName !== (masterUser.userLName ? masterUser.userLName : '') &&
          user.userPhone !== (masterUser.userPhone ? masterUser.userPhone : '') &&
          user.userEmail !== (masterUser.userEmail ? masterUser.userEmail : '')
        );

        // console.log("filteredUsers",filteredUsers)


        const finalUsers = [clonedArray, ...filteredUsers];

        if (!isEqual(carrierUsers, finalUsers)) {
       setSameMasterUser(true);
       dispatch(
        updateFormField({
          group: 'carrier',
          key: 'carrierUsers',
          value: finalUsers
        })
        );
      } 

      console.log("tempMasterUser",tempMasterUser);
      } 
      
      // else {
      // // Remove any existing user that matches the carrier info (based on userLName = companyName)
      // const filteredUsers = carrierUsers.filter(
      //   (user) =>
      //     user.userLName !== masterUser.userLName &&
      //     user.userPhone !== masterUser.userPhone &&
      //     user.userEmail !== masterUser.userEmail
      // );

      // // Ensure masterUser is first
      // const finalUsers = [masterUser, ...filteredUsers];

      // if (!isEqual(carrierUsers, finalUsers)) {
      //  setSameMasterUser(true);
      //  dispatch(
      //   updateFormField({
      //     group: 'carrier',
      //     key: 'carrierUsers',
      //     value: finalUsers
      //   })
      //   );
      // } 
      // }
  }, [carrierUsers, carrier?.invMail, carrier?.invMob, carrier?.companyName]);


  return (
    <div className="">
      <Form
        form={form}
        initialValues={{
          ...carrier,
        }}
        trigger="onChange"
      >
        <div className="carrier-data-form">
          <p className="mt-2 mr-0 color-blue-3 text-bold font-size-24">
            Στοιχεία Επιχείρησης
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields2_1.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span}>
                { field.name !== 'additionalKAD' ?
                    <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    value={renderFieldValue(field)}
                    validateFirst
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled || viewMode}
                      {...omit(field, ['span', 'rules', 'offset'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                  :
                  <div> 
                    <Label label={field.label} asterisk={field.asterisk}/>
                    <div id="firmField" className="scrollable-container">
                        {!isEmpty(filteredKadFirms) ? filteredKadFirms?.map((firm, index) => (
                          <div key={index} className="firm-item">
                            {firm}
                          </div>
                          ))
                          : 
                          <div key={index} className="firm-item">
                            -
                          </div>
                        }
                    </div>
                  </div>
                }
                </Col>
              );
            })}
          </Row>
        </div>
        <div className="carrier-data-form carrier-data-form__right">
          <p className="mt-0 mr-0 color-blue-3 text-bold font-size-24">
            Διεύθυνση Έδρας Επιχείρησης
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields2_2.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    validateFirst
                    value={renderFieldValue(field)}
                  >
                    <FormField
                      key={index}
                      disabled={viewMode
                        || ((field.name == 'abiPerfecture' || field.name == 'abiDistrict'))}
                      {...omit(field, ['span', 'rules'])}
                      options={
                        field.name === 'abiPerfecture'
                          ? abiPerfectureOptions
                          : field.name === 'abiDistrict'
                          ? abiDistrictOptions
                          : field.name === 'abiTk'
                          ? tkOptions
                          : ''
                      }
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </div>
      </Form>
      
      {/* <Row
        gutter={{ xs: 0, sm: 2, md: 5, lg: 10 }}
        className="carrier-data-form__row mt-6 sorefsis"
      >
        <Col span={20} className="sorefsis-col-1">
          <>
            <Sorefsis></Sorefsis>
          </>
        </Col>
        <Col span={4} className="sorefsis-col-2">
          <div className="mt-1">
            <SorefsisChart
              realValue={totalAmountSorefsis ? totalAmountSorefsis : 0}
              limit={mainKAD?.startsWith("01") ? process.env.REACT_APP_SOREFSIS_AMOUNT_KAD_01 : process.env.REACT_APP_SOREFSIS_AMOUNT }
            />
          </div>
          <div>
            {!viewMode && totalAmountSorefsis > (mainKAD?.startsWith("01") ? process.env.REACT_APP_SOREFSIS_AMOUNT_KAD_01 : process.env.REACT_APP_SOREFSIS_AMOUNT) && (
              <div
                role="alert"
                className="ant-form-item-explain-error mt-0 mb-2"
              >
                Το Σύνολο Σώρευσης έχει υπερβεί το Όριο Deminimis κατά{' '}
                {formattedNumber(totalAmountSorefsis - (mainKAD?.startsWith("01") ? process.env.REACT_APP_SOREFSIS_AMOUNT_KAD_01 : process.env.REACT_APP_SOREFSIS_AMOUNT))}€
              </div>
            )}
          </div>
        </Col>
      </Row> */}
    </div>
  );
};

export default CompanyDetails;
